/**
 * All supported http request methods.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
 *
 * @type {Object<number>}
 */
const HttpMethod = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete',
    PATCH: 'patch'
};

export default HttpMethod;
